import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  specialties: {
    crm: {},
    cro: {},
    crn: {},
    crp: {},
    crfa: {},
    crbm: {},
    crefito: {},
    croo: {},
    crf: {},
    coren: {},
    cfep: {},
    cref: {},
  },
  searchByName: {
    professionals: null,
    searchText: '',
  },
  searchResults: {
    professionals: null,
    searchText: '',
    lastId: null,
    total: 0,
  },
  searchFilters: {},
  slotsByAgenda: {},
  searchingSlots: false,
  slotsFailed: false,
};

export default function searchesReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return {
        ...initState,
      };
    case actions.SEARCH_BY_NAME_FETCH_SUCCESS:
      return {
        ...state,
        searchByName: {
          professionals: action.payload.data,
          searchText: action.payload.search,
        },
        searchingByName: false,
      };
    case actions.SEARCH_PROFESSIONALS_SUCCESS: {
      const total = typeof action.payload.total === 'number'
        ? action.payload.total
        : state.searchResults.total;
      return {
        ...state,
        searchResults: {
          professionals: action.payload.data,
          lastId: action.payload.lastId,
          total,
          searchText: action.payload.search,
        },
        searchingProfessionals: false,
      };
    }
    case actions.SEARCH_BY_NAME_FETCH_ERROR:
      return {
        ...state,
        searchByName: {
          ...state.searchByName,
          professionals: null,
        },
        searchingByName: false,
      };
    case actions.SEARCH_PROFESSIONALS_ERROR:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          professionals: null,
          lastId: null,
          total: 0,
        },
        searchingProfessionals: false,
      };
    case actions.SEARCHING_BY_NAME:
      return {
        ...state,
        searchByName: {
          ...state.searchByName,
          professionals: null,
        },
      };
    case actions.SEARCHING_PROFESSIONALS:
      return {
        ...state,
        // searchResults: {
        //   ...state.searchResults,
        //   professionals: null,
        // },
        searchingProfessionals: true,
      };
    // case actions.CLEAR_SEARCH_BY_NAME:
    //   return {
    //     ...state,
    //     searchByName: INITIAL_STATE.searchByName,
    //   };
    case actions.SEARCH_SLOTS_REQUEST:
      return {
        ...state,
        searchingSlots: true,
        slotsFailed: false,
      };
    case actions.SEARCH_SLOTS_SUCCESS: {
      const slotsByAgenda = { ...state.slotsByAgenda };
      action.payload.forEach((item) => {
        slotsByAgenda[`${item.ownerUid}|${item.addressId}|${item.agendaId}`] = item;
      });
      return {
        ...state,
        slotsByAgenda,
        searchingSlots: false,
      };
    }
    case actions.SEARCH_SLOTS_ERROR:
      return {
        ...state,
        searchingSlots: false,
        slotsFailed: true,
      };
    case actions.CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchByName: {
          ...state.searchByName,
          professionals: [],
        },
        searchResults: {
          ...state.searchResults,
          professionals: [],
          searchText: '',
          lastId: null,
          total: 0,
        },
        slotsByAgenda: {},
        searchingSlots: false,
        slotsFailed: false,
      };
    case actions.GET_SEARCH_FILTERS_SUCCESS:
      return {
        ...state,
        searchFilters: action.payload,
      };
    default:
      return state;
  }
}
